import { Actor, SpriteSheet } from "excalibur";
import { Resources } from "../Resources";

export default class BoxRepresentation extends Actor {
  constructor(pos) {
    super({ x: pos.x, y: pos.y });
    this.inspectBoxSprites = SpriteSheet.fromImageSource({
      image: Resources.InspectBoxSprites,
      grid: { rows: 4, columns: 12, spriteHeight: 80, spriteWidth: 80 },
    });
    this.open = this.inspectBoxSprites.getSprite(0, 3);
    this.openOne = this.inspectBoxSprites.getSprite(1, 3);
    this.openTwo = this.inspectBoxSprites.getSprite(2, 3);
    this.openThree = this.inspectBoxSprites.getSprite(3, 3);
    this.openFour = this.inspectBoxSprites.getSprite(4, 3);
    this.openFive = this.inspectBoxSprites.getSprite(5, 3);
    this.openSix = this.inspectBoxSprites.getSprite(6, 3);
    this.openSeven = this.inspectBoxSprites.getSprite(7, 3);
    this.openEight = this.inspectBoxSprites.getSprite(8, 3);
    this.openNine = this.inspectBoxSprites.getSprite(9, 3);
    this.openTen = this.inspectBoxSprites.getSprite(10, 3);
    this.graphics.add("open", this.open);
    this.graphics.add("openOne", this.openOne);
    this.graphics.add("openTwo", this.openTwo);
    this.graphics.add("openThree", this.openThree);
    this.graphics.add("openFour", this.openFour);
    this.graphics.add("openFive", this.openFive);
    this.graphics.add("openSix", this.openSix);
    this.graphics.add("openSeven", this.openSeven);
    this.graphics.add("openEight", this.openEight);
    this.graphics.add("openNine", this.openNine);
    this.graphics.add("openTen", this.openTen);
  }
}
